import { render, staticRenderFns } from "./BlockWithInitials.vue?vue&type=template&id=8be83e6c&"
import script from "./BlockWithInitials.vue?vue&type=script&lang=js&"
export * from "./BlockWithInitials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports